import { useTranslation } from 'react-i18next';

import { IconButton, styled, TextFieldProps } from '@mui/material';
import { LocalizationProvider, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DATE_FORMAT } from 'constants/formats';
import 'dayjs/locale/uk'

import { ReactComponent as CalendarMonthIcon } from 'assets/icons/Calendar.svg';

import { FormField } from 'components/_basic/Form/FormField/FormField';

import { IDatePickerProps } from './types';
import { TextInput } from '../../TextInput';

import styles from './DatePicker.module.scss';

const StyledPickerButtonStart = styled(IconButton)(({ theme }) => ({
  marginLeft: theme.spacing(0),
  marginRight: theme.spacing(-2),
}));

const StyledPickerButtonEnd = styled(IconButton)(({ theme }) => ({
  marginLeft: theme.spacing(0.3),
  marginRight: theme.spacing(0),
}));

const DatePickerIconButton = {
  start: StyledPickerButtonStart,
  end: StyledPickerButtonEnd,
};

const Input = (props: TextFieldProps) => <TextInput className={styles.inputNoRightPadding} {...props} />;

export const DatePicker: React.FC<IDatePickerProps> = ({
  label,
  fullWidth = true,
  position = 'end',
  dateFormat = DATE_FORMAT,
  fieldError,
  id,
  value,
  ...rest
}) => {
  const { i18n } = useTranslation();
  return (
    <FormField id={id} label={label} error={fieldError?.message} disabled={rest.disabled}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n.language}>
        <MuiDatePicker
          format={dateFormat}
          slots={{
            textField: Input,
            openPickerIcon: CalendarMonthIcon,
            openPickerButton: DatePickerIconButton[position],
          }}
          slotProps={{
            inputAdornment: {
              position,
            },
            textField: {
              id,
              error: !!fieldError?.message,
              fullWidth,
            },
            field: {
              clearable: false,
            },
          }}
          value={value}
          {...rest}
        />
      </LocalizationProvider>
    </FormField>
  );
};
